import CompaniesCard from '@components/CompaniesCard/index';
import React from 'react';
import SectionLayout from '../layouts/SectionLayout/index';

const SkillSectionV2 = (props) => {
  const categories = Object.entries(props.skills || {});

  return (
    <SectionLayout
      {...props}
      heading={props.heading || `Technologies You'll Master`}
      description={props.description}
    >
      <div className="container">
        <div className="flex w-full flex-col items-center gap-y-5">
          <div className="flex w-full flex-col items-center">
            {categories.map(([key, category], index) => (
              <CompaniesCard
                key={key}
                title={category.title}
                headerBackgroundColor="bg-v5-green-200 text-white"
                companyImages={category.skills}
                className={index === 0 ? 'mt-12' : ''}
                isCarousel={true}
                grayscale={props.grayscale}
              />
            ))}
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default SkillSectionV2;
